import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import ImageviewerModal from "../../../../components/modals/imageViewerModal/imageviewerModal";
import { ModalId } from "../../../../enums/modalId";
import { closeModal as closeReduxModal } from "../../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../../redux/store/store";
import {
  UserGeneralInfoContextKeys,
  UserStore,
} from "../../../../store/UserGeneralInfoStore";
import AllPaOrdersForExternalTableByAlgolia from "./components/allPaOrdersForExternalTableByAlgolia";

/**
 * Page wrapper for the external PA orders worklist.
 * Renders the search-backed table and manages modal state for image/doc viewers.
 *
 * @returns The external PA orders page layout with table and conditional modals
 */
const AllPaOrdersForExternal = () => {
  const dispatch = useDispatch<AppDispatch>();
  const allPaOrdersForExternalTableRef = useRef<HTMLDivElement>(null);
  const { openedModalId, metaData } = useSelector(
    (state: RootState) => state.modal,
  );

  useEffect(() => {
    UserStore.setItem(
      UserGeneralInfoContextKeys.PARENT_TABLE,
      window.location.pathname.split("/").slice(-1)[0],
    );
  }, []);

  useEffect(() => {
    if (openedModalId === ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION) {
      openModal(ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION);
    }
    if (openedModalId === ModalId.IMAGE_VIEWER_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL);
    }
  }, [openedModalId]);

  return (
    <div className="all-pa-orders-for-external--main-container flex h-full flex-col overflow-hidden">
      <div className="all-pa-orders-for-external__header mb-4 text-h11 font-bold text-primaryGray-1">
        All PA Orders
      </div>
      <div className="all-pa-orders-for-external__table-container flex-1 overflow-auto">
        <AllPaOrdersForExternalTableByAlgolia
          allPaOrdersForExternalTableRef={allPaOrdersForExternalTableRef}
        />
      </div>
      <>
        {openedModalId === ModalId.IMAGE_VIEWER_MODAL && (
          <ImageviewerModal
            fileUrls={metaData?.fileUrls ?? []}
            filePaths={metaData?.filePaths ?? []}
            onClose={() => dispatch(closeReduxModal())}
            showLoader={metaData?.showLoader ?? false}
          />
        )}
      </>
    </div>
  );
};

export default AllPaOrdersForExternal;
